export var MyEvents = [
    {
        title: "erste Probe nach den Sommerferien",
        allDay: true,
        start: new Date(2022,8,17),
        end: new Date(2022,8,17)
    },
    {
        title: "Grillfest für Mitglieder und Helfer",
        allDay: true,
        start: new Date(2023,10,2),
        end: new Date(2023,10,3)
    },
    {
        title: "Kulturwochenende in der Eichenberghalle",
        allDay: true,
        start: new Date(2022,9,22),
        end: new Date(2022,9,23)
    },{
        title: "Adventskonzert in der St. Martinus-Kirche",
        allDay: true,
        start: new Date(2022,11,18),
        end: new Date(2022,11,18)
    },{
        title: "JHV",
        allDay: true,
        start: new Date(2023,0,21),
        end: new Date(2023,0,21)
    }
]